/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function MoonStars(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M240,80H224V64a8,8,0,0,0-16,0V80H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V96h16a8,8,0,0,0,0-16Z" />
        <Path d="M152,48h8v8a8,8,0,0,0,16,0V48h8a8,8,0,0,0,0-16h-8V24a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Z" />
        <Path d="M216.457,144.64941a7.985,7.985,0,0,0-2.15576.35254A84.0314,84.0314,0,0,1,111.01514,41.6377a8.00171,8.00171,0,0,0-9.96485-9.96192A100.01377,100.01377,0,1,0,224.33936,154.89746a8.00114,8.00114,0,0,0-7.88233-10.24805Z" />
      </G>
    </Svg>
  );
}

export default MoonStars;
